<template>
  <div
    class="crew-member d-flex align-items-center"
    :class="{ assigned: !techMode && assigned, archived: crewMember.archived }"
  >
    <div class="d-flex align-items-center crew-member-name-cont">
      <i
        v-if="!crewMember.archived && (techMode || !assigned)"
        class="fa-regular fa-grip-lines-vertical vertical-lines"
      ></i>
      <tooltip
        :disabled="techMode || !tooltipMessage"
        :options="{ appendTo: 'parent', interactive: false }"
        placement="top"
        class="crew-member-tooltip"
      >
        <template #trigger>
          <div class="d-flex align-items-center">
            <department-icon
              v-if="isInDifferentDept"
              :department="crewMember.department"
              class="mr-1"
            ></department-icon>
            <truncate-text :text="crewMember.full_name"></truncate-text>
          </div>
        </template>
        <template #tooltip>
          <div>
            {{ tooltipMessage }}
          </div>
        </template>
      </tooltip>
    </div>
    <i
      v-if="techMode"
      class="fa-regular fa-times unassign-link"
      @click="emitAction('unassign')"
    ></i>
    <actions-menu
      v-else
      :actions="actions"
      :options="{
        theme: 'light crew-member-actions-menu'
      }"
      @edit="toggleModal"
      @unassign="emitAction('unassign')"
      @archive="emitAction('archive')"
      @unarchive="emitAction('unarchive')"
    ></actions-menu>
    <crew-member-modal
      v-if="editModal"
      :crew-member="crewMember"
      :link="crewMember.links.crew_member_update"
      @hide-modal="toggleModal"
    ></crew-member-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

import ActionsMenu from "@/components/ActionsMenu.vue";
import DepartmentIcon from "@/components/DepartmentIcon.vue";
import Tooltip from "@/components/Tooltip.vue";
import TruncateText from "@/components/TruncateText.vue";
import CrewMemberModal from "./CrewMemberModal.vue";

export default {
  components: {
    ActionsMenu,
    Tooltip,
    DepartmentIcon,
    CrewMemberModal,
    TruncateText
  },
  props: {
    crewMember: {
      type: Object,
      default: () => ({})
    },
    techMode: {
      // true when crew member is rendered in a technician card
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editModal: false
    };
  },
  computed: {
    ...mapState(["department"]),
    actions() {
      return [
        {
          icon: "fa-regular fa-edit",
          label: "Edit",
          eventName: "edit",
          disabled: !this.crewMember.links.crew_member_update
        },
        {
          icon: "fa-regular fa-archive",
          label: "Archive",
          eventName: "archive",
          visible: this.crewMember.links.crew_member_archive
        },
        {
          icon: "fa-regular fa-box-open",
          label: "Unarchive",
          eventName: "unarchive",
          visible: this.crewMember.links.crew_member_unarchive
        },
        {
          icon: "fa-regular fa-times",
          label: "Unassign",
          eventName: "unassign",
          disabled: !this.crewMember.links.crew_member_unassign,
          visible: !this.crewMember.links.crew_member_unarchive
        }
      ];
    },
    assigned() {
      return !!this.crewMember.assigned_to;
    },
    isInDifferentDept() {
      return this.crewMember.department.id !== this.department.id;
    },
    tooltipMessage() {
      const { archived, assigned_to } = this.crewMember;
      let label = "";
      if (archived) {
        label += "Archived ";
      }
      if (this.assigned) {
        label += `Assigned to ${assigned_to.full_name}`;
      }
      return label;
    }
  },
  methods: {
    emitAction(actionName) {
      this.$emit(actionName, this.crewMember);
    },
    toggleModal() {
      this.editModal = !this.editModal;
    }
  }
};
</script>

<style lang="scss" scoped>
.crew-member {
  border-radius: 25px;
  padding: 5px 10px;
  box-shadow: var(--box-shadow);
  background-color: var(--uranian-blue);
  border: 1px solid var(--gray-border-color);
  margin-bottom: 10px;
  cursor: pointer;
  &.assigned {
    background-color: #fff;
    border: 2px dashed var(--secondary-color);
  }
  &.archived {
    text-decoration: line-through;
    font-style: italic;
    background-color: #fff;
    color: var(--gray);
  }
}
.unassign-link {
  color: var(--primary-color);
  font-size: 1.3em;
  position: relative;
  top: 1px;
}

.vertical-lines {
  padding-top: 2px;
  margin-right: 5px;
}

$close-icon-width: 13px;
.crew-member-name-cont,
.crew-member-tooltip {
  width: calc(100% - #{$close-icon-width});
}
</style>
